import React, { useContext } from 'react';
import { useTheme } from '@mui/material/styles';
import { IconProps } from './iconProps';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';

export default function IconVerticalDots({
  extColor,
  isAutoscallable = true,
  sizeKey = '20x20',
  onClick,
  style,
}: IconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.primary.main;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0007 16.6548C9.54566 16.6548 9.15647 16.493 8.83241 16.1689C8.50834 15.8448 8.34648 15.4556 8.34648 15.0007C8.34648 14.5457 8.50834 14.1565 8.83241 13.8324C9.15647 13.5083 9.54566 13.3465 10.0007 13.3465C10.4556 13.3465 10.8448 13.5083 11.1689 13.8324C11.493 14.1565 11.6548 14.5457 11.6548 15.0007C11.6548 15.4556 11.493 15.8448 11.1689 16.1689C10.8448 16.493 10.4556 16.6548 10.0007 16.6548ZM10.0007 11.6548C9.54566 11.6548 9.15647 11.493 8.83241 11.1689C8.50834 10.8448 8.34648 10.4556 8.34648 10.0007C8.34648 9.54566 8.50834 9.15647 8.83241 8.83241C9.15647 8.50834 9.54566 8.34648 10.0007 8.34648C10.4556 8.34648 10.8448 8.50834 11.1689 8.83241C11.493 9.15647 11.6548 9.54566 11.6548 10.0007C11.6548 10.4556 11.493 10.8448 11.1689 11.1689C10.8448 11.493 10.4556 11.6548 10.0007 11.6548ZM10.0007 6.65482C9.54566 6.65482 9.15647 6.49296 8.83241 6.1689C8.50834 5.84483 8.34648 5.45564 8.34648 5.00065C8.34648 4.54566 8.50834 4.15647 8.83241 3.83241C9.15647 3.50834 9.54566 3.34648 10.0007 3.34648C10.4556 3.34648 10.8448 3.50834 11.1689 3.83241C11.493 4.15647 11.6548 4.54566 11.6548 5.00065C11.6548 5.45564 11.493 5.84483 11.1689 6.1689C10.8448 6.49296 10.4556 6.65482 10.0007 6.65482Z"
        fill={fill}
        stroke={fill}
        strokeWidth="0.025"
      />
    </svg>
  );
}
